export default "__VITE_ASSET__DUR_0GFZ__"